export const fadeInDuration = 200;
export const fadeOutDuration = 200;
export const fadeOutDelay = 300;

export const popupAndSlideInDuration = 500;
export const slideOutDuration = 300;

const prefix = 'hc-action-sheet';

export const ActionSheetClassNames = {
  Root: `${prefix}-root`,
  Overlay: `${prefix}-overlay`,
  Sheet: `${prefix}-sheet`,
  SheetHeader: `${prefix}-sheet-header`,
  SheetContent: `${prefix}-sheet-content`,
  SheetFooter: `${prefix}-sheet-footer`,
  Title: `${prefix}-title`,
};

const varPrefix = `--${prefix}`;

export const ActionSheetVariableNames = {
  FooterHeight: `${varPrefix}-footer-height`,
};
